<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Concept des Sacs Publicitaires",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout },
  data() {
    return {
      currentIndex: 0,
      inView: [],
      direction: null,  
      steps: [
        { number: 1, icon: "check-circle", alt: "check-circle", title: "concept.1.title", description: "concept.1.description", fulldescription:'concept.1.fulldescription' , list:"concept.1.list" },
        { number: 2, icon: "setting-line", alt: "printer", title: "concept.3.title", description: "concept.3.description", fulldescription:'concept.3.fulldescription' },
        { number: 3, icon: "map-point-rotate", alt: "map-point-rotate", title: "concept.2.title", description: "concept.2.description", fulldescription:'concept.2.fulldescription' },
        { number: 4, icon: "printer", alt: "setting-line", title: "concept.4.title", description: "concept.4.description", fulldescription:'concept.4.fulldescription' },
        // { number: 5, icon: "check-circle", alt: "Validation Icon", title: "concept.5.title", description: "concept.5.description" },
        // { number: 6, icon: "machinery", alt: "machinery", title: "concept.6.title", description: "concept.6.description" },
        // { number: 7, icon: "printer", alt: "Impression Fabrication Icon", title: "concept.7.title", description: "concept.7.description" },
        { number: 5, icon: "delivery-truck", alt: "Livraison Icon", title: "concept.8.title", description: "concept.8.description" , fulldescription:'concept.8.fulldescription'}
      ],
    };
  },
  computed: {
    stepsPerPage() {
      const width = window.innerWidth;
      if (width >= 1024) {
        return 5;
      } else if (width >= 768) {
        return 3; 
      } else if (width >= 500){
        return 2; 
      }else {
        return 1; 
      }
    },
    visibleSteps() {
      return this.steps.slice(this.currentIndex, this.currentIndex + this.stepsPerPage);
    },
  },

  methods: {


    navigate(direction) {
      this.direction = direction;
            if (direction === 'next') {
        this.currentIndex = Math.min(this.currentIndex + 1, this.steps.length - 1);
      } else if (direction === 'prev') {
        this.currentIndex = Math.max(this.currentIndex - 1, 0);
      }
      this.initializeObserver();

    },
  



    initializeObserver() {
      const options = {
        root: null,
        threshold: 0.1,
      };
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const index = parseInt(entry.target.dataset.index);
          if (entry.isIntersecting) {
            this.$set(this.inView, index, true);
          }
        });
      }, options);

      // Ensure that each ref has the dataset index set and is observed
      this.$refs.stepRefs.forEach((step, index) => {
        if (step) {
          step.dataset.index = index;
          observer.observe(step);
        } else {
          console.warn(`Missing step reference for index: ${index}`);
        }
      });
    },
  
  },
  mounted() {
    this.inView = new Array(this.steps.length).fill(false);
    this.$nextTick(() => this.initializeObserver());
  },
};
</script>



<template>
  <Layout>
    <div class="bg-white text-center  pt-md-5 pb-md-5 pt-0 pb-0">
      <div>
        <div class="pt-0 pr-2 pl-2">
          <h1 class="pt-5 text-dark text-wrap font-weight-bold" style="font-size:2.5rem;">
            {{$t('concept.concept')}}
          </h1>
        </div>

        <hr class="separator-line mt-3 mb-3">

        <div class="mt-5">
          <h6 class="header-60-width mx-auto text-dark font-size-16 text-wrap" style="letter-spacing: 0.08em; line-height: 1.8;">
            <strong>{{$t('concept.companyName')}}</strong> {{$t('concept.subTitle')}}
          </h6>
        </div>
      </div>
    </div>


    <!-- <div class="pt-4 text-center ">
      
          <div class="pt-5 text-dark font-weight-bold " style="font-size:50px">
            {{$t('concept.processus')}} <strong>{{$t('concept.companyName')}}</strong>
          </div>

          <div class="header-60-width mx-auto text-primary text-wrap" style="font-size:30px">
            {{$t('concept.diffusion')}}
          </div>

        </div> -->
    

<div class="bg-white d-none d-md-block">
    <div class="timeline-container pr-5 pl-5 bg-white" >

      


      <button v-if="currentIndex != 0" class="nav-btn prev-btn" @click="navigate('prev')" >
        <img alt="arrow-left" width="30px" src="@/assets/icons/arrow-left-2-w.svg" />
      </button>

      <div class="timeline " >
      <div
        v-for="(step, index) in visibleSteps"
        :key="step.id"
        class="step"
        :class="{
          'in-view': inView[index]

        }"
        ref="stepRefs"
      >
        
        <div v-if="step" class="text-center">
          <div class="icon mt-2 mb-3">
            <img :alt="step.alt" :src="require(`@/assets/icons/${step.icon}.svg`)" class="mr-0 ml-0" />
          </div>
          
        </div>
        <div class="circle">{{ step.number }}</div>

        <div class="pt-3">
          <h3 class="text-primary">{{ $t(step.title) }}</h3>
          <p class="text-dark">{{ $t(step.description) }}</p>
        </div>
      </div>
    </div>

      <button v-if="!(currentIndex + stepsPerPage >= steps.length)" class="nav-btn next-btn" @click="navigate('next')" > 
        <img alt="arrow-right" width="30px" src="@/assets/icons/arrow-right-2-w.svg"/>
      </button>

    </div>
  </div>

    <div class="bg-white pt-5 pb-5">
      <div class="row  bg-white">

        <div class="col-12 mt-5" v-for="(step) in steps" :key="step.id">
          <div class="header-60-width" style=" display: flex; align-items: center; ">
            <span class="circle" >{{ step.number }}</span> 
            <span class="ml-3 text-primary font-size-22 font-weight-bold"> {{ $t(step.title) }} </span>
          </div>

          <p  class="header-60-width text-dark text-justify mt-3 font-size-16" style="line-height: 1.8; letter-spacing: 0.08em;">
              {{ $t(step.fulldescription) }}
          </p>

          <ul v-if="step.number == 1" class="header-60-width text-justify text-dark mt-2 font-size-16">
            <li v-for="(item, index) in $t(step.list).split('/*/')" :key="index" >
              <span style="line-height: 1.8; letter-spacing: 0.08em;" > {{ item.trim() }}</span>
            </li>
          </ul>



          <div v-if="step.number == 2" class="header bg-primary pt-3 mt-4 ">
      <div class="row header-60-width text-left ">
        <div class="col-md-4 col-12">
          <div class="text-white font-weight-bold text-uppercase" style="font-size:1.3rem" >{{$t('concept.campagneZone')}}</div>
          <div class="mt-4" style="font-size:1.3rem ; color:#f7d584" > <strong>{{$t('concept.companyName')}}</strong>{{$t('concept.needes')}}</div>
          <div class="mt-4 font-size-16 mt-4 text-white"> {{$t('concept.description1')}} <strong>{{$t('concept.companyName')}}</strong>
            {{$t('concept.description2')}}
          </div>
        </div>

        <div class="col-md-4 col-12 text-center d-md-block d-none">
          <img alt="tn-map" width="250px" src="@/assets/icons/TN_marker_map-Design.svg" class="mr-0" />
        </div>

        <div class="col-md-4 col-12 pl-md-5 pl-0 mt-md-0 mt-5 d-md-block d-none text-right" >
          <div class="float-right">

            
            <div class="cercle-1 text-primary ">
              <div class="font-weight-bold" style="font-size: 50px;">{{$t('concept.morethane1500')}}</div>
              <div class="font-weight-bold" style="font-size: 30px;">{{$t('concept.partner')}}</div>
              <div class="font-size-16 pr-3 pl-2">{{$t('concept.agreed')}} <strong>{{$t('concept.companyName')}}</strong></div>
            </div>

            <div class="cercle-2 text-primary text-center mt-3">
              <div class="font-size-16 p-3" style="font-size: 25px;">
                {{$t('concept.description3')}}
              </div>
            </div>
          </div>

      </div>
      
      <div class="col-md-4 col-12 pl-md-5 pl-0 mt-md-0 mt-5 d-md-none d-block" >
          <div class="text-center">

            <hr class="separator-line mt-3 mb-3">

            <div class="text-white ">
              <div class="font-weight-bold" style="font-size: 50px;">{{$t('concept.morethane1500')}}</div>
              <div class="font-weight-bold" style="font-size: 30px;">{{$t('concept.partner')}}</div>
              <div class="font-size-16 pr-3 pl-2">{{$t('concept.agreed')}} <strong>{{$t('concept.companyName')}}</strong></div>
            </div>

            <div class="text-white text-center mt-3">
              <div class="font-size-16 p-3" style="font-size: 25px;">
                {{$t('concept.description3')}}
              </div>
            </div>
          </div>

      </div>


      </div>

    </div>





        </div>

      </div>
    </div>

    

    <div class="pt-5  mb-3 pb-5 text-center bg-primary">
      <div class="mb-4 p-md-0 p-2">
        <div class="text-white font-weight-bold " style="font-size: 20px" >
          {{$t('concept.advisors01')}}
        </div>
          <div class="text-white font-weight-bold " style="font-size: 20px" >
            {{$t('concept.advisors02')}}
        </div>
      </div>
     
      <a class="pr-3 bg-wh" href="/devis">
        <b-button variant="warning"  style="padding: 10px 26px; letter-spacing:3px;" class="font-weight-bold font-size-18 m-md-0 m-2">
          <div class="font-weight-normal d-none d-md-block font-size-12">Je souhaite améliorer ma visibilité </div>
          <span class="d-none d-md-inline">Demander un </span>Devis Gratuit
        </b-button>
      </a>  

     <div class="font-size-12 mt-2 text-light text-uppercase">{{$t('default.requestQuoteResponse')}}</div> 
    </div>

    






  </Layout>
</template>


<style scoped>


.header {
  background:  linear-gradient(19deg,rgba(55, 152, 91, 1) 0%,rgba(19, 116, 55, 1) , rgba(23, 83, 45, 1) 100%)!important;
  text-align: center;
}

.header-60-width,
.sub-title-60-width {
  max-width: 90%;
  margin: auto;
}

@media (min-width: 768px) {
  .header-60-width,
  .sub-title-60-width {
      max-width: 60%;
  }
}
.separator-line {
  width: 15%;
  height: 4px;
  background-color: #137437; /*#f7d584 ;*/
  border: none;
  margin: auto;
}

.sub-title-60-width {
  margin: 30px auto 0;
  color: #f7d584;
}

.responsive-iframe {
  height: 450px;
}

@media (min-width: 768px) {
  .responsive-iframe {
      height: 650px;
  }
}





</style>

<style scoped>
.timeline-container {
  display: flex;
  align-items: center;
  max-width: 1500px;
  margin: auto;
  position: relative;

}

 .nav-btn {
  background-color: #137437 ;
  color: white;
  border: none;
  padding: 5px 9px;
  cursor: pointer;
  font-size: 1.5rem;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.nav-btn:hover {
  background-color: #056127;
  transform: scale(1.2);
}

.nav-btn:disabled {
  background-color: #72c591;
  cursor: not-allowed;
} 



.timeline {
  display: flex;
  min-height: 150px;
  position: relative;
  width: 100%;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #137437;
}

.step {
  top: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  text-align: center;
  opacity: 0;
  transform: scale(0.9) translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
  height: 250px; 
}

.step.in-view {
  opacity: 1;
  transform: scale(1) translateY(0);
}


.circle {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #137437, #57b479);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 25px;
  font-weight: bold;
  box-shadow: 0px 4px 10px #57b479;
  transition: all 0.3s ease;
}



.icon img {
  width: 75px;
  padding-bottom: 10px;
}

h3 {
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
}

p {
  font-size: 0.9rem;
  color: #555;
}


</style>


<style scoped>
.cercle-1 {
  width: 270px;
  height: 270px;
  background: white;
  display: flex; /* Enables flexbox */
  flex-direction: column; /* Arranges content vertically */
  align-items: center; /* Centers content horizontally */
  justify-content: center; /* Centers content vertically */
  border-radius: 50%;
  transition: all 0.3s ease;
}

.cercle-2 {
  transform: translateY(-45px);
  width: 210px;
  height: 210px;
  background: white;
  display: flex; /* Enables flexbox */
  flex-direction: column; /* Arranges content vertically */
  align-items: center; /* Centers content horizontally */
  justify-content: center; /* Centers content vertically */
  border-radius: 50%;
  transition: all 0.3s ease;
}
</style>